import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-quiz-progress',
  templateUrl: './view-quiz-progress.component.html',
  styleUrls: ['./view-quiz-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizProgressComponent implements OnInit {
  @Input()
  index = 0;

  @Input()
  total = 0;

  constructor() { }

  ngOnInit(): void {
  }

}
